import { picDataFormat, filterParams } from '@/common/utils/format'
import { get, pick } from 'lodash-es'
import { i18n, getBDCountry, sprintf } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'


const KEYS = ['itemPics']

export function revert (data = {}) {
  const shopData = get(data, 'shopGlobal')
  let revertted = {}
  if (shopData) {
    revertted = pick(shopData, KEYS)
    revertted.itemPics = picDataFormat(shopData.itemPics, shopData.itemPics)
  }
  return revertted
}

export function submitFormat (shopGlobal) {
    return {
      params: JSON.stringify({
        source: 'contractor',
        queryId: this.id,
        shopGlobal
      })
    }
  }

export default {
  revert,
  submitFormat
}
